import { MouseEvent } from 'react';

const TEXT_FIELDS = 'input, textarea, select';

/**
 * mousedown handler for popups: cancels the word/paragraph selection a double or triple
 * click makes (e.g. clicking the button that opens the popup twice), while a press-and-drag
 * still selects text and form fields keep their own double-click behaviour.
 */
export const preventMultiClickSelection = (event: MouseEvent) => {
  const target = event.target as Element;
  if (event.detail > 1 && !target.closest?.(TEXT_FIELDS)) {
    event.preventDefault();
  }
};
